// Shared preset lists for the expense Category / Vendor comboboxes.
// Both fields are typeable — these are just starting suggestions.
export const EXPENSE_CATEGORIES = [
  "Pool", "Grounds & Landscaping", "Maintenance & Repairs",
  "Gas", "Fuel", "Rent", "Utilities", "Supplies", "Vehicle maintenance",
  "Insurance", "Phone & Internet", "Software", "Marketing",
  "Credit card charge", "Taxes & fees", "Bank fees",
  "Other",
];

// Client-side fallback shown instantly while the live list loads from
// GET /expenses/vendors (which also includes any vendor another user typed).
export const DEFAULT_VENDOR_OPTIONS = [
  "Home Depot", "Wechsler", "Walmart", "Amazon", "WPS Plumbing", "MEP Electric", "ACE",
];

export async function fetchVendorOptions(api, ledger) {
  try {
    const { data } = await api.get("/expenses/vendors", { params: ledger ? { ledger } : {} });
    return Array.isArray(data) && data.length ? data : DEFAULT_VENDOR_OPTIONS;
  } catch (_) {
    return DEFAULT_VENDOR_OPTIONS;
  }
}

// Same idea for Category — merges the presets above with any categories an
// admin added from Settings for their own ledger/business.
export async function fetchCategoryOptions(api, ledger) {
  try {
    const { data } = await api.get("/expenses/categories", { params: ledger ? { ledger } : {} });
    return Array.isArray(data?.categories) && data.categories.length ? data.categories : EXPENSE_CATEGORIES;
  } catch (_) {
    return EXPENSE_CATEGORIES;
  }
}
